<template>
    <div id="customerInfo">
        <el-row class="clearfix" style="margin-bottom: 15px;">
            <el-col class="fl" :span="2">
                <el-button size="small"  type="warning" @click="backGo()">返回</el-button>
            </el-col>
            <el-col class="fr" :span="1">
                <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
            </el-col>
        </el-row>
        <el-col class="fl searthPart" style="width: 20%;">
            <el-form ref="returnForm" :model="returnForm" label-width="80px" :label-position="labelPosition">
                <p class="headerT">客户信息</p>
                <el-form-item label="客户账号">
                    <el-input :disabled="true" v-model.trim="returnForm.telephoneNo"></el-input>
                </el-form-item>
                <el-form-item label="客户姓名">
                    <el-input :disabled="true" v-model.trim="returnForm.customerName" ></el-input>
                </el-form-item>
                <el-form-item label="绑定微信">
                    <el-input :disabled="true" v-if="returnForm.openId" value="是"></el-input>
                    <el-input :disabled="true" v-if="!returnForm.openId" value="否"></el-input>
                </el-form-item>
                <el-form-item label="注册时间">
                    <el-input :disabled="true" v-model.trim="returnForm.createTime" ></el-input>
                </el-form-item>
                <p class="headerT">地址信息</p>
                <el-form-item label="联系人">
                    <el-input :disabled="true" v-model.trim="returnForm.customerName"></el-input>
                </el-form-item>
                <el-form-item label="联系电话">
                    <el-input :disabled="true" v-model.trim="returnForm.telephoneNo" ></el-input>
                </el-form-item>
                <el-form-item label="地址">
                    <el-input :disabled="true" type="textarea" v-model.trim="returnForm.totalAddress" ></el-input>
                </el-form-item>
            </el-form>
        </el-col>
        <el-col class="fr" style="width: 78%;">
            <el-card class="box-card fr" style="width: 100%;">
                <el-table
                    :data="returnData"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%">
                    <el-table-column
                        align="center"
                        prop="orderNo"
                        width="200"
                        label="工单编号">
                    </el-table-column> 
                    <el-table-column
                        align="center"
                        width="150"
                        prop="modelName"
                        label="型号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="200"
                        label="故障">
                        <template slot-scope="scope">
                            <span style="display:block" v-for="(item,index) in scope.row.faultSubclass" :key="index">{{item.faultSubclassName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="150"
                        label="下单时间">
                        <template slot-scope="scope">
                            {{scope.row.createTime | date}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="200"
                        label="预约时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.onsiteDate}} {{scope.row.onsiteTimeStart}} ~ {{scope.row.onsiteTimeEnd}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="250"
                        label="客户信息">
                        <template slot-scope="scope">
                            <span style="display:block">{{scope.row.customerName}} {{scope.row.telephoneNo | getTel}}</span>
                            <span v-if="scope.row.provinceName != '上海市' && scope.row.provinceName != '北京市'">{{scope.row.provinceName}}{{scope.row.cityName}}{{scope.row.countyName}}{{scope.row.address}}</span>
                            <span v-else>{{scope.row.provinceName}}{{scope.row.countyName}}{{scope.row.address}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="sum"
                        width="100"
                        label="工单状态">
                        <template slot-scope="scope">
                            {{scope.row.adminStatus | sysCodeFileter('admin_status')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="sum"
                        width="100"
                        label="工单类型">
                        <template slot-scope="scope">
                            {{scope.row.serviceType | sysCodeFileter('order_type')}}
                        </template>
                    </el-table-column>
                </el-table>
                <!--分页-->
                <el-col :span="24" class="toolbar">
                    <div class="pagination">
                        <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pages.page"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="pages.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="pages.total">
                        </el-pagination>
                    </div>
                </el-col>
            </el-card>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    import clip from '@/util/clipboard'
    import {
        transferLibraryDetails,
        transferLibraryDetailsList,
        ClientDetails,
        ClientDetailsList
    } from "../../api/api";
    export default {
        name: 'customerInfo',
        components: {},
        data () {
            return {
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                orderId:'',
                telephoneNo:'',
                labelPosition:'left',
                returnForm:{},
                returnData: []
            }
        },
        created(){
            this.$destroy(); //销毁生命周期
            if (!this.$route.query.id) {
                this.orderId = sessionStorage.getItem('saveOrderId');
                this.telephoneNo = sessionStorage.getItem('saveTelephoneNo');
            }else{
                this.orderId = this.$route.query.id;
                this.telephoneNo = this.$route.query.telephoneNo;
                sessionStorage.setItem('saveTelephoneNo', this.$route.query.telephoneNo);
            }

            this.getClientDetails();
            this.getClientDetailsList();
        },
        methods: {
            //获取订单详情
            getClientDetails() {
                let para={
                    id: this.orderId
                }
                ClientDetails(para).then(res => {          
                    if (res.data.status==100) { 
                        this.returnForm = res.data.results;
                        this.returnForm.createTime = this.filters.formatDate(this.returnForm.createTime);
                        sessionStorage.setItem('saveOrderId', res.data.results.id);
                        if(this.returnForm.provinceName == '上海市' || this.returnForm.provinceName == '北京市'){
                            this.returnForm.totalAddress = this.returnForm.provinceName+this.returnForm.countyName+this.returnForm.address
                        }else{
                            this.returnForm.totalAddress = this.returnForm.provinceName+this.returnForm.cityName+this.returnForm.countyName+this.returnForm.address
                        }           
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取订单详情
            getClientDetailsList() {
                let para={
                    telephoneNo: this.telephoneNo,
                    startRow: this.pages.page,
                    pageSize: this.pages.pageSize
                }
                ClientDetailsList(para).then(res => {          
                    if (res.data.status==100) { 
                        this.returnData = res.data.results.list
                        this.pages.total = res.data.results.total            
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //返回上一页
            backGo() {
                this.$router.back(-1);
            },
            refresh() {
                this.getClientDetails()
                this.getClientDetailsList()
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getClientDetailsList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getClientDetailsList()
            }
        },
        computed: {
            
        },
        watch: {
          
        },
    
    }
</script>

<style type="text/css" lang="scss" scoped>
    #customerInfo{
        font-size: 14px;
        .copyBtn{font-size: 24px;cursor: pointer;display:block;float: right;}
        .el-input{width: 85%;}
        .headerT{font-size: 16px;margin:0 0 15px 0;}
        .toolbar{margin: 20px 0;}
        .el-button+.el-button {
            margin-left: 0px;
        }
        .el-step__line{background-color: #1abc9c;}
        .el-step__icon-inner{color:#1abc9c;}
        /*.el-step__icon{width: 10px;height: 10px;}*/
        .el-step__icon.is-text{border-color: #1abc9c;}
    }
    .dialog-content{
        width:900px;
        margin:0 auto;
        .dialog-code-content{
            text-align: center;
            .el-col{
                p{
                    border: 1px solid #e3e3e3;
                    line-height: 40px
                }
                
            }
        }
    }
  
</style>



// WEBPACK FOOTER //
// customerInfo.vue?16ac248c